<template>
    <v-container>
        <v-card>
            <v-toolbar flat color="#1d2735" dark>
                <v-toolbar-title>
                    {{ $route.query.id != null ? "Editar" : "Crear" }}
                    abono</v-toolbar-title
                >
            </v-toolbar>
            <v-card-text>
                <v-form ref="form">
                    <div class="font-weight-bold mb-3 black--text">
                        DATOS DEL CLIENTE Y FECHA
                    </div>
                    <v-row align="center">
                        <v-col cols="12" md="2">
                            <v-text-field
                                dense
                                outlined
                                label="Nro"
                                v-model="factura.nro_factura"
                                disabled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <date-select
                                v-model="factura.fecha"
                                label="Fecha"
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                dense
                                outlined
                                v-model="factura.id_cliente"
                                :items="usuarios"
                                item-value="id"
                                item-text="nombres"
                                label="Cliente"
                                :rules="[rules.required]"
                                :readonly="$route.query.id ? true : false"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                dense
                                outlined
                                v-model="factura.id_factura"
                                :items="facturas"
                                item-value="id"
                                item-text="nro_anio_factura"
                                label="Factura asociada"
                                :rules="[rules.required]"
                                :readonly="$route.query.id ? true : false"
                            ></v-autocomplete>
                        </v-col>
                        <!-- v-col cols="12" md="4">
                        <v-autocomplete dense outlined v-model="id_proyecto" :items="proyectos" item-value="id" item-text="nombre" label="Proyecto"></v-autocomplete>
                        </>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="cliente" outlined dense label="Cliente"></v-text-field>
                        </v-col> -->

                        <v-col cols="12" md="6">
                            <v-text-field
                                dense
                                outlined
                                v-model="factura.nombre_cliente"
                                label="Nombre fiscal"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                dense
                                outlined
                                :rules="[rules.cifOrDni]"
                                v-model="factura.cif_cliente"
                                label="CIF/DNI"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                dense
                                outlined
                                v-model="factura.domicilio"
                                label="Domicilio"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-checkbox
                                v-model="factura.kit"
                                label="¿Es kit?"
                                :readonly="guardado ? true : false"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-checkbox
                                v-model="factura.enviado"
                                label="Enviado al cliente"
                                :readonly="guardado ? true : false"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                outlined
                                label="Descripción-notas"
                                v-model="factura.notas"
                                :readonly="guardado ? true : false"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-form>

                <!-- DATOS DEL SERVICIO A FACTURAR -->
                <div class="font-weight-bold mb-3 black--text">
                    DATOS DEL SERVICIO A FACTURAR
                </div>
                <v-row>
                    <v-col cols="12" md="3">
                        <v-textarea
                            v-model="linea.descripcion"
                            outlined
                            dense
                            label="Descripción"
                            rows="1"
                            auto-grow
                            row-height="15"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            type="number"
                            v-model="linea.cantidad"
                            outlined
                            dense
                            label="Cantidad"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            type="number"
                            v-model="linea.precio"
                            outlined
                            dense
                            label="Precio"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            type="number"
                            v-model="linea.importe"
                            outlined
                            dense
                            label="Importe"
                            readonly
                        ></v-text-field>
                    </v-col>
                </v-row>
                <div class="mb-5">
                    <v-btn
                        v-if="editing == null"
                        @click="HandlerAdd()"
                        color="primary"
                        class="white--text"
                        rounded
                        :disabled="guardado ? true : false"
                    >
                        Agregar servicio
                    </v-btn>
                    <v-btn
                        v-else
                        @click="HandlerAdd()"
                        color="primary"
                        class="white--text"
                        rounded
                        :disabled="guardado ? true : false"
                    >
                        Actualizar servicio
                    </v-btn>
                    <v-btn
                        @click="LimpiarServicio()"
                        color="red"
                        class="white--text"
                        rounded
                        :disabled="guardado ? true : false"
                    >
                        Limpiar servicio
                    </v-btn>
                </div>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="factura.items_factura"
                    disable-pagination
                    hide-default-footer
                    class="elevation-1"
                >
                    <template v-slot:item.descripcion="{ item }">
                        <p class="pre-wrap">{{ item.descripcion }}</p>
                    </template>
                    <template v-slot:item.importe="{ item }">
                        {{ formatPrice(item.importe) }}
                    </template>
                    <template v-slot:item.precio="{ item }">
                        {{ formatPrice(item.precio) }}
                    </template>
                    <template v-slot:item.action="{ item }" v-if="!guardado">
                        <v-icon @click="editItem(item)" color="primary"
                            >mdi-pencil</v-icon
                        >
                        <v-icon @click="deleteItem(item)" color="red"
                            >mdi-delete</v-icon
                        >
                    </template>
                </v-data-table>

                <!-- DESCUENTOS Y TOTALES -->
                <div class="font-weight-bold mb-3 black--text my-3">
                    DESCUENTOS Y TOTALES
                </div>
                <v-row justify="space-between">
                    <v-col cols="12" md="2">
                        <v-text-field
                            type="numeric"
                            v-model="factura.descuento"
                            outlined
                            dense
                            label="Descuento %"
                            @change="calcula_total()"
                            :readonly="guardado ? true : false"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            dense
                            outlined
                            v-model="factura.id_cuenta"
                            :items="cuentas"
                            item-value="id"
                            item-text="nombre_banco"
                            label="Banco"
                            readonly
                        ></v-autocomplete>
                        <v-autocomplete
                            dense
                            outlined
                            v-model="factura.id_cuenta"
                            :items="cuentas"
                            item-value="id"
                            item-text="cuenta"
                            label="Cuenta bancaria"
                            :readonly="guardado ? true : false"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card class="px-2 py-2">
                            <span class="font-weight-bold"
                                >Sub Total: {{ formatPrice(subTotal()) }}€</span
                            ><br />
                            <span class="font-weight-bold"
                                >Descuento:
                                {{ formatPrice(descuento()) }}€</span
                            ><br />
                            <span class="font-weight-bold"
                                >Iva:
                                {{ formatPrice(HandlerIva(false)) }}€</span
                            ><br />
                            <span class="font-weight-bold"
                                >Total:
                                {{ formatPrice(this.factura.total) }}€</span
                            >
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-checkbox
                        label="incluir IVA 21%"
                        color="primary"
                        v-model="factura.status_iva"
                        @change="HandlerIva(true)"
                        :readonly="guardado ? true : false"
                    ></v-checkbox>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- Botones Navegacion -->
        <v-row class="mt-3">
            <v-col cols="12">
                <!-- Volver -->
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="$router.push('/lista-facturas-devolucion')"
                            :loading="isloading"
                            :disabled="isloading"
                            color="blue"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-arrow-left-bold-outline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Volver</span>
                </v-tooltip>

                <!-- Guardar -->
                <!-- <v-tooltip top v-if="!guardado"> -->
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="guardarFactura()"
                            :loading="isloading"
                            :disabled="isloading"
                            color="success"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-content-save-all</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Guardar Factura</span>
                </v-tooltip>

                <!-- Duplicar -->
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            v-if="$route.query.id != null"
                            @click="duplicarFactura()"
                            :loading="isloading"
                            :disabled="isloading"
                            color="success"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
                                />
                            </svg>
                        </v-btn>
                    </template>
                    <span>Duplicar</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <ProyectosSinFacturarDialog
            v-model="dialog_proyectos"
            :id_cliente="factura.id_cliente"
        ></ProyectosSinFacturarDialog>

        <ConfirmDialog
            v-model="dialog_confirm"
            titulo="Confirmar datos cliente"
            texto="Se han actualizado los datos del cliente, ¿quieres actualizar la factura?"
            :data="datos_cliente"
            @confirm="confirmarDatosCliente"
        ></ConfirmDialog>
    </v-container>
</template>

<script>
import { rules } from "../../../../utils/rules";
import ProyectosSinFacturarDialog from "../../componentes/ProyectosSinFacturarDialog.vue";
import dateSelect from "../../../../components/general/dateSelect.vue";
import { formatPrice } from "../../../../utils/formatters";
import ConfirmDialog from "../../../../global_components/VConfirmDialog.vue";

export default {
    name: "FormFacturaDevolucion",
    components: {
        ProyectosSinFacturarDialog,
        dateSelect,
        ConfirmDialog,
    },
    setup() {
        return {
            rules: rules,
        };
    },
    data() {
        return {
            // Variables generales
            dialog_proyectos: false,
            menu2: false,
            iva: parseFloat(0).toFixed(2),
            usuarios: [],
            proyectos: [],
            cuentas: [],
            cliente: {},
            guardado: false,
            dialog_confirm: false,

            // headers de la tabla de servicios a facturar
            headers: [
                { text: "Descripción", value: "descripcion", sortable: false },
                { text: "Cantidad", value: "cantidad", sortable: false },
                { text: "Precio", value: "precio", sortable: false },
                { text: "Importe", value: "importe", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],

            // Factura
            factura: {
                id: null,
                id_factura: null,
                id_proyecto: null,
                total: parseFloat(0).toFixed(2),
                descuento: 0,
                fecha: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                )
                    .toISOString()
                    .substr(0, 10),
                id_cuenta: 2,
                items_factura: [],
                status_iva: true,
                nro_factura: 0,
                id_cliente: null,
                nombre_cliente: "",
                cif_cliente: "",
                domicilio: "",
                notas: "",
                kit: false,
                enviado: false,
            },

            facturas: [],

            // se usa al guardar la factura para eliminar items
            id_items_factura: [],

            // Datos del cliente
            datos_cliente: {
                same: {
                    nombre_cliente: "",
                    cif_cliente: "",
                    domicilio: "",
                },
                new: {
                    nombre_cliente: "",
                    cif_cliente: "",
                    domicilio: "",
                },
            },

            // Editar servicio a facturar
            editing: null,
            linea: {
                id: null,
                descripcion: "",
                cantidad: 1,
                precio: parseFloat(0).toFixed(2),
                importe: parseFloat(0).toFixed(2),
            },
        };
    },
    created() {
        this.getActiveClientes();
        this.getAllCuentas();

        if (this.$route.query.cliente != null) {
            this.id_cliente = parseInt(this.$route.query.cliente);
        }
        if (this.$route.query.id != undefined) {
            this.getFacturaId(this.$route.query.id);
        } else {
            this.getLastNroFacturaDevolucion();
        }
    },
    watch: {
        "factura.id_cliente": function (val) {
            // this.getProyectosByUser(val, 0);
            this.getFacturasByCliente(val);
            this.getCliente(val);
        },
        "factura.id_factura": async function (val) {
            if (val != null) {
                console.log("val", val);

                await this.setItemsFactura(val);

                if (
                    this.factura.id == null ||
                    this.factura.notas == null ||
                    this.factura.notas == ""
                ) {
                    const nro_factura =
                        this.facturas.length > 0
                            ? this.facturas.find(
                                  (factura) => factura.id === val
                              )?.nro_anio_factura
                            : this.factura.factura.nro_anio_factura;

                    this.factura.notas =
                        "Abono correspondiente a la factura " + nro_factura;
                }
            }
        },
        "linea.cantidad": function (n) {
            this.linea.importe = parseFloat(n * this.linea.precio).toFixed(2);
        },
        "linea.precio": function (n) {
            this.linea.importe = parseFloat(n * this.linea.cantidad).toFixed(2);
        },
    },
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        errors() {
            return this.$store.getters.geterrors;
        },
    },
    methods: {
        // Acciones de factura
        async getFacturaId(id) {
            try {
                const response = await axios.get(
                    `api/facturas/devolucion/${id}`
                );
                this.factura = response.data;

                this.comprobarDatosCliente(this.factura);

                this.guardado = this.factura.enviado ? true : false;

                if (response.data.id_cliente == null) {
                    this.id_cliente = response.data.cliente_real.id;
                }
                //this.getProyectoById(this.id_proyecto)
                this.calcula_total();
                // this.fecha = response.data.fecha;
            } catch (error) {
                console.log(error);
            }
        },
        async guardarFactura() {
            if (!this.$refs.form.validate()) {
                return;
            }
            try {
                (this.factura.id_proyecto =
                    (this.id_proyecto ?? 0) == "" ? 0 : this.id_proyecto ?? 0),
                    (this.factura.descuento = this.descuento);

                if (this.$route.query.id) {
                    // Editar
                    const res = await axios.put(
                        `api/facturas/devolucion/${this.$route.query.id}`,
                        this.factura
                    );
                    console.log("res", res);
                    // Eliminar items
                    /*if (this.id_items_factura.length > 0) {
                        const request_item = {
                            id_items_factura: this.id_items_factura,
                        };
                        await axios.post("api/delete-items-facturas", request);
                    }*/
                    this.$toast.sucs(res.data.message);
                } else {
                    // Registro
                    const res = await axios.post(
                        "api/facturas/devolucion",
                        this.factura
                    );

                    const data = res.data.data;
                    const message = res.data.message;

                    this.$router.push(
                        `registrar-factura-devolucion?id=${data.id}`
                    );
                    this.$router.go();
                    this.$toast.sucs(message);
                }

                /*if (this.$route.meta.name == "facturas") {
                    this.dialog_proyectos = true;
                }*/

                this.guardado = this.factura.enviado ? true : false;
            } catch (error) {
                const error_data = error.response.data.error;
                const error_message = error.response.data.message;
                if (typeof error_data === "string") {
                    this.$toast.error(error_message);
                } else {
                    const error_list = Object.values(error_data);
                    const msg_error = error_list.flat();

                    let lt = `<ul>`;
                    for (const iterator of msg_error) {
                        lt = lt + `<li>${iterator}</li>`;
                    }
                    lt = lt + `</ul>`;
                    this.$toast.error("Error guardando la factura" + lt);
                }
            }
        },
        async getLastNroFacturaDevolucion() {
            try {
                const res = await axios.get(
                    "api/get-last-nro-factura-devolucion"
                );

                this.factura.nro_factura =
                    res.data != null && res.data != undefined ? res.data : 1;
            } catch (error) {
                console.log(error);
            }
        },

        comprobarDatosCliente(facturaData) {
            // Comprueba si la relacion de factura con cliente no es nula
            if (facturaData.cliente != null) {
                let provincia = "";
                if (facturaData.cliente.provincia != null) {
                    provincia = facturaData.cliente.provincia.nombre;
                }

                const domicilio =
                    (facturaData.cliente.direccion ?? "") +
                    (facturaData.cliente.codigo_postal != null
                        ? "-- C.P."
                        : "") +
                    (facturaData.cliente.codigo_postal ?? "") +
                    " " +
                    (facturaData.cliente.localidad ?? "") +
                    " " +
                    provincia;

                // Comprueba si los datos del cliente han cambiado
                if (
                    facturaData.nombre_cliente !=
                        facturaData.cliente.nombre_fiscal ||
                    facturaData.cif_cliente != facturaData.cliente.cif ||
                    facturaData.domicilio != domicilio
                ) {
                    // Si han cambiado, muestra el dialogo de confirmacion
                    this.datos_cliente.new = {
                        nombre_cliente: facturaData.cliente.nombre_fiscal,
                        cif_cliente: facturaData.cliente.cif,
                        domicilio: domicilio,
                    };
                    this.datos_cliente.same = {
                        nombre_cliente: facturaData.nombre_cliente,
                        cif_cliente: facturaData.cif_cliente,
                        domicilio: facturaData.domicilio,
                    };
                    this.dialog_confirm = true;
                } else {
                    // Si no han cambiado, mantiene los datos del cliente
                    this.factura.nombre_cliente = facturaData.nombre_cliente;
                    this.factura.cif_cliente = facturaData.cif_cliente;
                    this.factura.domicilio = facturaData.domicilio;
                }
            } else {
                // Si no hay relacion de factura con cliente, mantiene los datos del cliente
                this.factura.nombre_cliente = facturaData.nombre_cliente;
                this.factura.cif_cliente = facturaData.cif_cliente;
                this.factura.domicilio = facturaData.domicilio;
            }
        },
        confirmarDatosCliente(data) {
            // Actualiza los datos del cliente
            this.factura.nombre_cliente = data.nombre_cliente;
            this.factura.cif_cliente = data.cif_cliente;
            this.factura.domicilio = data.domicilio;
        },

        duplicarFactura() {
            axios
                .get(
                    `api/duplicar-factura/${this.$route.query.id}/${this.tipo}`
                )
                .then((res) => {
                    this.$router.push(`/registrr-facturas?id=${this.id}`);
                });
        },

        // Agregar servicio a facturar
        HandlerAdd() {
            if (
                this.linea.descripcion != "" &&
                this.linea.cantidad != "" &&
                this.linea.precio != "" &&
                this.linea.importe != ""
            ) {
                const item = {
                    descripcion: this.linea.descripcion,
                    cantidad: this.linea.cantidad,
                    precio: this.linea.precio,
                    importe: this.linea.importe,
                    id: Date.now() + "a",
                };
                if (this.editing != null) {
                    const linea = this.factura.items_factura.find(
                        (ele) => ele == this.editing
                    );
                    const index = this.factura.items_factura.findIndex(
                        (ele) => ele == this.editing
                    );
                    // console.log(index);
                    // console.log(linea);
                    linea.descripcion = item.descripcion;
                    linea.cantidad = item.cantidad;

                    linea.precio = item.precio;

                    linea.importe = item.importe;
                    this.factura.items_factura[index] = linea;
                    console.log(this.factura.items_factura);
                } else {
                    this.factura.items_factura.push(item);
                }

                this.LimpiarServicio();
                /*this.id = Date.now() + "a";
                this.descripcion = "";
                this.quantity = "";
                this.price = "";
                this.imp = "";
                this.editing = null;*/
                this.calcula_total();
            }
        },
        editItem(item) {
            this.editing = item;
            let elemento_data = JSON.parse(JSON.stringify(item));

            this.linea.descripcion = elemento_data.descripcion;
            this.linea.cantidad = elemento_data.cantidad;
            this.linea.precio = elemento_data.precio;
            this.linea.importe = elemento_data.importe;
            this.linea.id = elemento_data.id;

            //this.deleteItem(item);
        },
        deleteItem(item) {
            const search = this.factura.items_factura.indexOf(item);
            if (search > -1) {
                this.factura.items_factura.splice(search, 1);
            }
            this.calcula_total();
        },
        LimpiarServicio() {
            this.editing = null;
            this.linea = {
                id: Date.now() + "a",
                descripcion: "",
                cantidad: 1,
                precio: parseFloat(0).toFixed(2),
                importe: parseFloat(0).toFixed(2),
            };
        },
        async setItemsFactura(id_factura) {
            const factura = this.facturas.find(
                (fact) => fact.id === id_factura
            );

            if (factura != undefined) {
                factura.items_factura.forEach((item) => {
                    item.cantidad = item.cantidad * -1;
                    item.importe = item.importe * -1;
                });
                this.factura.items_factura = factura.items_factura;
                this.calcula_total();
            }
        },

        // Metodos generales
        getAllCuentas() {
            axios.get(`api/get-cuentas-banco`).then(
                (res) => {
                    this.cuentas = res.data;
                },
                (res) => {
                    this.$toast.error("Error consultando Cuentas Bancarias");
                }
            );
        },
        getActiveClientes() {
            let url = `api/get-all-clientes-active-proyectos`;
            if (this.$route.meta.name != "facturas")
                url = "api/get-all-clientes?potencial=true";
            axios.get(url).then(
                (res) => {
                    if (this.$route.meta.name != "facturas") {
                        this.usuarios = res.data;
                    } else {
                        this.usuarios = res.data.users;
                    }
                    for (let i = 0; i < this.usuarios.length; i++) {
                        const element = this.usuarios[i];
                        element.created_at = new Date(
                            element.created_at
                        ).toLocaleDateString();
                    }
                },
                (err) => {
                    this.$toast.error("Error consultando Usuario");
                }
            );
        },

        // Busca los proyectos del usuario/cliente seleccionado
        getProyectosByUser(userId, tipo) {
            axios.get(`api/get-proyectos-by-user-id/${userId}/${tipo}`).then(
                (res) => {
                    this.proyectos = res.data;
                    if (this.$route.query.proyecto != undefined) {
                        this.id_proyecto = parseInt(this.$route.query.proyecto);
                    }
                },
                (res) => {
                    this.$toast.error("Error consultando proyectos");
                }
            );
        },
        getCliente(id_cliente) {
            if (this.usuarios.length > 0) {
                this.cliente = this.usuarios.find(
                    (element) => element.id == id_cliente
                );
            }

            let provincia = "";
            if (this.cliente.provincia != null) {
                provincia = this.cliente.provincia.nombre;
            }

            const domicilio =
                (this.cliente.direccion ?? "") +
                (this.cliente.codigo_postal != null ? "-- C.P." : "") +
                (this.cliente.codigo_postal ?? "") +
                " " +
                (this.cliente.localidad ?? "") +
                " " +
                provincia;

            // Si factura.id (route.query.id) es null entonces establecer los valores de nombre, cif y domicilio
            // de cliente segun el cliente seleccionado
            if (!this.$route.query.id) {
                this.factura.nombre_cliente = this.cliente.nombre_fiscal;
                this.factura.cif_cliente = this.cliente.cif;
                this.factura.domicilio = domicilio;
            }
        },
        async getFacturasByCliente(id_cliente) {
            try {
                console.log("id_cliente", id_cliente);
                const response = await axios.get(`api/facturas/${id_cliente}`);

                // Asegurarnos de que this.facturas sea siempre un array
                this.facturas = Array.isArray(response.data)
                    ? response.data
                    : [];

                // Actualizar los restos si hay ingresos previos
                /*this.ingreso_factura_iniciales.forEach((ele) => {
                    const factura = this.facturas.find(
                        (fact) => fact.id === ele.factura_id
                    );
                    if (factura) {
                        factura.resto = parseFloat(factura.resto) + ele.importe;
                    }
                });*/
            } catch (error) {
                console.error("Error al obtener facturas:", error);
                this.facturas = []; // En caso de error, asegurarnos de que sea un array vacío
            }
        },

        // Metodos auxiliares
        subTotal() {
            const total = this.factura.items_factura.reduce((acc, arr) => {
                acc = parseFloat(acc) + parseFloat(arr.importe);
                acc = parseFloat(acc).toFixed(2);
                return acc;
            }, 0);
            return total;
        },
        descuento() {
            let descuentoNeto =
                (this.subTotal() * this.factura.descuento) / 100;
            return descuentoNeto;
        },
        HandlerIva(calculatotal) {
            if (this.factura.status_iva == true) {
                const number =
                    parseFloat(this.subTotal()).toFixed(2) -
                    parseFloat(this.descuento()).toFixed(2);
                const mult = (number * 21) / 100;
                this.iva = mult;
                let ivacalc = parseFloat(mult).toFixed(2);
                if (calculatotal) {
                    this.calcula_total();
                }
                return mult;
            } else {
                this.iva = 0;
                if (calculatotal) {
                    this.calcula_total();
                }
                return 0;
            }
        },
        calcula_total() {
            let subtotal = this.subTotal();
            subtotal = parseFloat(subtotal).toFixed(2);
            let descuento = this.descuento();
            descuento = parseFloat(descuento).toFixed(2);
            let iva = this.HandlerIva(false);
            this.factura.total = subtotal - descuento + iva;
            return parseFloat(this.factura.total).toFixed(2);
        },
        formatPrice,
    },
};
</script>
<style>
.pre-wrap {
    white-space: pre-wrap;
}
.w-6 {
    width: 2rem;
    height: 2rem;
    color: white;
}
</style>
